import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface FidelityState {
    numberArchived: number;
    numberActive: number;
    isAssociateModalOpened: boolean;
    localShop: string[];
    isAssociateModalClosed: boolean;
    numberActiveMultiShop: number;
    numberArchiveMultiShop: number;
    idsLocalShop: string[];
    isAssociatedFidelity: boolean;
    selectedRows: FidelityRow[];
    ids: number;
    shopsFidelityData: ShopsFidelityData;
    fidelityData: FidelityDataTable;
    rowsShop: ShopsFidelityShop[];
    archivedFidelityFranchise: FidelityDataTable;
    associatedFidelity: FidelityRow[];
    fidelityFranchise: FidelityDataTable;
    activeFidelity: FidelityActiveItem[];
    globalDataIsUpdated: boolean | number;
    dataArchive: FidelityRow[];
    dataActive: string[];
    dataFranchiseArchive: FidelityRow[];
    isArchived: boolean;
    message: string;
    fidelity: string;
    selectedRowsFidelity: FidelityRow | null;
    isAssignment: boolean;
    selectedFidelity: Array<Record<string, string>>;
    isConsultModalOpened: boolean;
    isActionsClicked: boolean;
    isEdited: boolean;
    modify: boolean;
    sortedVisibilityEdited: SaleModeVisibility[];
    edit: string;
    isSupportCodeValid: boolean;
    selectedShopId: string;
    archiveMessage: string;
    isLoading: boolean;
    key: string;
}

const initialState: FidelityState = {
    numberArchived: 0,
    numberActive: 0,
    isAssociateModalOpened: false,
    localShop: [],
    isAssociateModalClosed: false,
    numberActiveMultiShop: 0,
    numberArchiveMultiShop: 0,
    idsLocalShop: [],
    isAssociatedFidelity: false,
    selectedRows: [],
    ids: 0,
    shopsFidelityData: {},
    fidelityData: {},
    rowsShop: [],
    archivedFidelityFranchise: {},
    associatedFidelity: [],
    fidelityFranchise: {},
    activeFidelity: [],
    globalDataIsUpdated: false,
    dataArchive: [],
    dataActive: [],
    dataFranchiseArchive: [],
    isArchived: false,
    message: "",
    fidelity: "",
    selectedRowsFidelity: null,
    isAssignment: false,
    selectedFidelity: [],
    isConsultModalOpened: false,
    isActionsClicked: false,
    isEdited: false,
    modify: false,
    sortedVisibilityEdited: [],
    edit: "",
    isSupportCodeValid: false,
    selectedShopId: "",
    archiveMessage: "",
    isLoading: false,
    key: "",
};

const fidelitySlice = createSlice({
    name: "fidelity",
    initialState,
    reducers: {
        setKey: (state, action: PayloadAction<string>) => {
            state.key = action.payload;
        },
        setIsSupportCodeValid: (state, action: PayloadAction<boolean>) => {
            state.isSupportCodeValid = action.payload;
        },
        setSelectedShopId: (state, action: PayloadAction<string>) => {
            state.selectedShopId = action.payload;
        },
        setModify: (state, action: PayloadAction<boolean>) => {
            state.modify = action.payload;
        },
        setEdit: (state, action: PayloadAction<string>) => {
            state.edit = action.payload;
        },
        setNumberArchived: (state, action: PayloadAction<number>) => {
            state.numberArchived = action.payload;
        },
        setNumberActive: (state, action: PayloadAction<number>) => {
            state.numberActive = action.payload;
        },
        setSelectedFidelity: (
            state,
            action: PayloadAction<Array<Record<string, string>>>
        ) => {
            state.selectedFidelity = action.payload;
        },
        setIsAssociateModalOpened: (state, action: PayloadAction<boolean>) => {
            state.isAssociateModalOpened = action.payload;
        },
        setIsConsultModalOpened: (state, action: PayloadAction<boolean>) => {
            state.isConsultModalOpened = action.payload;
        },
        setLocalShop: (state, action: PayloadAction<string[]>) => {
            state.localShop = action.payload;
        },
        setIsAssociateModalClosed: (state, action: PayloadAction<boolean>) => {
            state.isAssociateModalClosed = action.payload;
        },
        setNumberActiveMultiShop: (state, action: PayloadAction<number>) => {
            state.numberActiveMultiShop = action.payload;
        },
        setNumberArchiveMultiShop: (state, action: PayloadAction<number>) => {
            state.numberArchiveMultiShop = action.payload;
        },
        setIdsLocalShop: (state, action: PayloadAction<string[]>) => {
            state.idsLocalShop = action.payload;
        },
        setIsAssociatedFidelity: (state, action: PayloadAction<boolean>) => {
            state.isAssociatedFidelity = action.payload;
        },
        setSelectedRow: (state, action: PayloadAction<FidelityRow[]>) => {
            state.selectedRows = action.payload;
        },
        setIds: (state, action: PayloadAction<number>) => {
            state.ids = action.payload;
        },
        setShopsFidelityData: (
            state,
            action: PayloadAction<ShopsFidelityData>
        ) => {
            state.shopsFidelityData = action.payload;
        },
        setFidelityData: (state, action: PayloadAction<FidelityDataTable>) => {
            state.fidelityData = action.payload;
        },
        setRowsShop: (state, action: PayloadAction<ShopsFidelityShop[]>) => {
            state.rowsShop = action.payload;
        },
        setArchivedFidelityFranchise: (
            state,
            action: PayloadAction<FidelityDataTable>
        ) => {
            state.archivedFidelityFranchise = action.payload;
        },
        setAssociatedFidelity: (
            state,
            action: PayloadAction<FidelityRow[]>
        ) => {
            state.associatedFidelity = action.payload;
        },
        setFidelityFranchise: (
            state,
            action: PayloadAction<FidelityDataTable>
        ) => {
            state.fidelityFranchise = action.payload;
        },
        setActiveFidelity: (
            state,
            action: PayloadAction<FidelityActiveItem>
        ) => {
            const incoming = action.payload;
            const index = state.activeFidelity.findIndex(
                (element) => element.Id === incoming.Id
            );
            if (index !== -1) {
                state.activeFidelity[index] = incoming;
            } else {
                state.activeFidelity.push(incoming);
            }
        },
        setGlobalDataIsUpdated: (
            state,
            action: PayloadAction<boolean | number>
        ) => {
            state.globalDataIsUpdated = action.payload;
        },
        setDataArchive: (state, action: PayloadAction<FidelityRow[]>) => {
            state.dataArchive = action.payload;
        },
        setDataActive: (state, action: PayloadAction<string[]>) => {
            state.dataActive = action.payload;
        },
        setDataFranchiseArchive: (
            state,
            action: PayloadAction<FidelityRow[]>
        ) => {
            state.dataFranchiseArchive = action.payload;
        },
        setIsArchived: (state, action: PayloadAction<boolean>) => {
            state.isArchived = action.payload;
        },
        setMessage: (state, action: PayloadAction<string>) => {
            state.message = action.payload;
        },
        setFidelity: (state, action: PayloadAction<string>) => {
            state.fidelity = action.payload;
        },
        setSelectedRowsFidelity: (
            state,
            action: PayloadAction<FidelityRow | null>
        ) => {
            state.selectedRowsFidelity = action.payload;
        },
        setIsAssignment: (state, action: PayloadAction<boolean>) => {
            state.isAssignment = action.payload;
        },
        setIsEdited: (state, action: PayloadAction<boolean>) => {
            state.isEdited = action.payload;
        },
        setSortedVisibilityEdited: (
            state,
            action: PayloadAction<SaleModeVisibility[]>
        ) => {
            state.sortedVisibilityEdited = action.payload;
        },
        setIsActionsClicked: (state, action: PayloadAction<boolean>) => {
            state.isActionsClicked = action.payload;
        },
        setArchiveMessage: (state, action: PayloadAction<string>) => {
            state.archiveMessage = action.payload;
        },
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        franchiseSelectionChanged: (
            state,
            action: PayloadAction<{
                idsLocalShop: string[];
                localShop: string[];
                selectedFidelity: Array<Record<string, string>>;
                fidelityData: FidelityDataTable;
                dataArchive: FidelityRow[];
                dataActive: string[];
                dataFranchiseArchive: FidelityRow[];
            }>
        ) => {
            const p = action.payload;
            state.idsLocalShop = p.idsLocalShop;
            state.localShop = p.localShop;
            state.selectedFidelity = p.selectedFidelity;
            state.fidelityData = p.fidelityData;
            state.archivedFidelityFranchise = p.fidelityData;
            state.fidelityFranchise = p.fidelityData;
            state.dataArchive = p.dataArchive;
            state.dataActive = p.dataActive;
            state.dataFranchiseArchive = p.dataFranchiseArchive;
        },
        shopSelectionSynced: (
            state,
            action: PayloadAction<{
                associatedFidelity: FidelityRow[];
                rowsShop: ShopsFidelityShop[];
                idsLocalShop: string[];
                localShop: string[];
                shopsFidelityData: ShopsFidelityData;
            }>
        ) => {
            const p = action.payload;
            state.associatedFidelity = p.associatedFidelity;
            state.rowsShop = p.rowsShop;
            state.idsLocalShop = p.idsLocalShop;
            state.localShop = p.localShop;
            state.shopsFidelityData = p.shopsFidelityData;
        },
    },
});

export const {
    setKey,
    setIsSupportCodeValid,
    setSelectedShopId,
    setModify,
    setEdit,
    setNumberArchived,
    setNumberActive,
    setSelectedFidelity,
    setIsAssociateModalOpened,
    setIsConsultModalOpened,
    setLocalShop,
    setIsAssociateModalClosed,
    setNumberActiveMultiShop,
    setNumberArchiveMultiShop,
    setIdsLocalShop,
    setIsAssociatedFidelity,
    setSelectedRow,
    setIds,
    setShopsFidelityData,
    setFidelityData,
    setRowsShop,
    setArchivedFidelityFranchise,
    setAssociatedFidelity,
    setFidelityFranchise,
    setActiveFidelity,
    setGlobalDataIsUpdated,
    setDataArchive,
    setDataActive,
    setDataFranchiseArchive,
    setIsArchived,
    setMessage,
    setFidelity,
    setSelectedRowsFidelity,
    setIsAssignment,
    setIsEdited,
    setSortedVisibilityEdited,
    setIsActionsClicked,
    setArchiveMessage,
    setIsLoading,
    franchiseSelectionChanged,
    shopSelectionSynced,
} = fidelitySlice.actions;

export default fidelitySlice.reducer;
